"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var staff_list_1 = require("../../components/staff/staff-list");
var invite_staff_1 = require("../../components/staff/invite-staff");
var Staff = function (_a) {
    var orgId = _a.match.params.orgId;
    var _b = React.useState(false), inviteModalOpen = _b[0], setInviteModalOpen = _b[1];
    var orgIdAsInt = parseInt(orgId);
    return (React.createElement("div", { id: "program", className: "container hub-full-width" },
        React.createElement("div", { className: "page-content u-xs-padXl u-flexExpandSides" },
            React.createElement("div", { className: "page-content-header Grid u-flexAlignItemsCenter" },
                React.createElement("div", { className: "Grid-cell u-xs-size1of2" },
                    React.createElement("h1", null, "Staff")),
                React.createElement("div", { className: "Grid-cell u-xs-size1of2 u-textRight button-list" },
                    React.createElement(teamsnap_ui_1.Button, { onClick: function () { return setInviteModalOpen(true); }, color: "primary", className: "Button u-flexShrink1", icon: "plus" }, "New Staff"))),
            React.createElement("div", { className: "page-content-body u-flex u-flexCol" },
                React.createElement(staff_list_1.default, { className: "u-flexGrow1", organizationId: orgIdAsInt }))),
        React.createElement(invite_staff_1.default, { isOpen: inviteModalOpen, onClose: function () { return setInviteModalOpen(false); }, orgId: orgIdAsInt })));
};
exports.default = Staff;
//# sourceMappingURL=staff.js.map